import axiosInstance from '../../lib/api/axios';
import { BFF_URL } from '../../lib/config';
import { IsStudentResponse } from './types';

export const isStudentRole = async (
  uuid: string,
): Promise<IsStudentResponse> => {
  const { data } = await axiosInstance.get<IsStudentResponse>(`${BFF_URL}/users/${uuid}/isStudent`);
  return data;
};
